import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=00f6e4b7&"
import script from "./SideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports